// extracted by mini-css-extract-plugin
export default {"title":"styles_title__T6VSK","header":"styles_header__9FCmj","modal":"styles_modal__5D1PS","modalContent":"styles_modalContent__PQGR8","body":"styles_body__4c5Zo"};